import Panel from 'portaltransparencia-common/components/Panel.react.js';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter';
import {
  changeFieldValue,
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import PageHeader from '../components/PageHeader.react.js';
import NotasExplicativas from '../notaexplicativa/Form.react';
import * as actions from './Actions.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import { compactText } from 'portaltransparencia-common/libs/TextCompact.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import FilterButtons from '../components/FilterButtons.react.js';
import UltimaAtualizacaoByTable from '../ultimaatualizacao/UltimaAtualizacaoByTable.react.js';
import ExportButtonGroup from 'portaltransparencia-common/components/ExportButtonGroup.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import { fromJS, Map } from 'immutable';
import { addErrorNotification } from 'portaltransparencia-common/ui/Actions.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import storageService from 'portaltransparencia-common/libs/StorageService.js';
import Hint from 'portaltransparencia-common/components/hint/Hint.react.js';
import moment from 'moment';

export class FormAcordoSemRecurso extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired,
    searchAcordos: PropTypes.func.isRequired,
    filtros: PropTypes.object,
    onChange: PropTypes.func,
    resetCrud: PropTypes.func.isRequired,
    addErrorNotification: PropTypes.func.isRequired,
    tipoSituacao: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.onResetFiltro('filtroAcordos');
  }

  onChangeFiltro = event => {
    const { onChange } = this.props;

    onChange('filtroAcordos', event);
  };

  getFilterByEntidadeAndExercicio = () => {
    const { entidade, exercicio } = storageService.getItem('userInfo');
    return `entidade=${entidade.id}&exercicio=${exercicio.id}`;
  };

  onResetFiltro = () => {
    const { resetCrud, searchAcordos } = this.props;
    resetCrud('filtroAcordos');
    searchAcordos(this.getFilterByEntidadeAndExercicio());
  };

  montaFilter = page => {
    const { filtros } = this.props;
    const baseFilter = this.getFilterByEntidadeAndExercicio();

    const fields = [
      'nomeFornecedor',
      'tipo',
      'situacao',
      'numero',
      'ano',
      'dataInicio',
      'dataTermino',
      'objeto',
      'dataInicioFim',
      'dataTerminoFim'
    ];

    const filter = fields.reduce((rsqlFilter, field) => {
      const filterByField = filtros.get(field);

      if (!filterByField) {
        return rsqlFilter;
      }

      if (
        (field === 'dataInicio' ||
          field === 'dataInicioFim' ||
          field === 'dataTerminoFim' ||
          field === 'dataTermino') &&
        filterByField.length !== 10
      ) {
        return rsqlFilter;
      }

      return addFilterUrl(rsqlFilter, `${field}=${filterByField}`);
    }, baseFilter);

    return addPagination(page, filter);
  };

  onConsultaAcordos = event => {
    if (event) {
      event.preventDefault();
    }

    const firstPage = this.props.page.set('number', 0);
    this.searchWithPage(firstPage);

    if (this.panelFiltro) {
      this.panelFiltro.collapse();
    }
  };
  searchWithPage = page => {
    const { searchAcordos } = this.props;

    let filter = this.montaFilter(page);

    searchAcordos(filter);
  };

  onViewDetalhes = item => {
    const id = item.get('id');

    this.props.history.push(`acordos-sem-recurso/${id}`);
  };

  renderAcordos = data => {
    const key = `${data.get('entidade')}_${data.get('exercicio')}_${data.get(
      'id'
    )}`;

    return (
      <TableActions
        ref="row"
        key={key}
        data={data}
        onMore={this.onViewDetalhes}
      >
        <td>{data.get('numero')}</td>
        <td>{data.get('ano')}</td>
        <td>{data.get('tipo')}</td>
        <td>{data.get('nomeFornecedor')}</td>
        <td>{data.get('situacao')}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('dataInicio'))} </td>
        <td>{DateUtils.formatDateTimeShort(data.get('dataTermino'))} </td>
        <td title={data.get('objeto')}>
          {compactText(data.get('objeto'), 110)}
        </td>
      </TableActions>
    );
  };

  onExporta = (exportType, openTab, windowParams) => {
    const { page, addErrorNotification } = this.props;
    const { apiURL } = configuration;

    if (page.get('content').size > 0) {
      let filtro = this.montaFilter(page) + '&exportType=' + exportType;

      window.open(
        `${apiURL}/api/acordos-sem-recurso/report?${filtro}`,
        openTab,
        windowParams
      );
    } else {
      addErrorNotification(
        'A consulta não apresentou resultado. Não é possível exportar para o formato selecionado!'
      );
    }
  };

  renderCombo = item => {
    return (
      <option key={item} value={item}>
        {item}
      </option>
    );
  };

  onChangeFiltroData = event => {
    const { onChange, filtros } = this.props;
    const { name, value } = event.target;

    const isCampoInicial = name === 'dataInicio' || name === 'dataTermino';
    const dataValida = moment(
      value,
      ['DD/MM/YYYY', 'YYYY-MM-DD'],
      true
    ).isValid();
    const fieldName = `${name}Fim`;

    if (dataValida) {
      this.onChangeFiltro({
        target: { name, value }
      });

      if (isCampoInicial && !filtros.get(fieldName)) {
        this.onChangeFiltro({
          target: {
            name: fieldName,
            value: value
          }
        });
      }
    }

    onChange('filtroAcordos', event);
  };

  onBlurFieldData = event => {
    const { filtros } = this.props;
    const { name, value } = event.target;

    const data = moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);

    if (!data.isValid()) {
      return;
    }

    const valorFormatado = data.format('YYYY-MM-DD');
    const campoFinal = `${name}Fim`;
    const isCampoInicial = name === 'dataInicio' || name === 'dataTermino';

    this.onChangeFiltro({
      target: {
        name,
        value: valorFormatado
      }
    });

    if (isCampoInicial && !filtros.get(campoFinal)) {
      this.onChangeFiltro({
        target: {
          name: campoFinal,
          value: valorFormatado
        }
      });
    }
  };

  render() {
    const { page, filtros, tipoSituacao, location } = this.props;

    if (!page.has('content')) {
      return null;
    }

    return (
      <section>
        <PageHeader location={location} />

        <NotasExplicativas pathname={location.pathname} />

        <Panel
          title="Consulta Acordos Sem Recursos Financeiros"
          isForm
          mobileClose
          ref={el => (this.panelFiltro = el)}
        >
          <form>
            <Row>
              <Col sm={8}>
                <Input
                  id="nomeFornecedor"
                  name="nomeFornecedor"
                  ref="nomeFornecedor"
                  placeholder="Parte Contratada"
                  label="Parte Contratada"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('nomeFornecedor')}
                />
              </Col>
              <Col sm={4}>
                <Input
                  id="tipo"
                  name="tipo"
                  ref="tipo"
                  placeholder="Tipo"
                  label="Tipo"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('tipo')}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Input
                  id="situacao"
                  name="situacao"
                  ref="situacao"
                  label="Situação"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('situacao')}
                >
                  <option value="">Todas</option>
                  {tipoSituacao.map(this.renderCombo)}
                </Input>
              </Col>
              <Col sm={4}>
                <Input
                  id="numero"
                  name="numero"
                  ref="numero"
                  placeholder="Número"
                  label="Número"
                  type="number"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('numero')}
                />
              </Col>
              <Col sm={4}>
                <Input
                  id="ano"
                  name="ano"
                  ref="ano"
                  placeholder="Ano"
                  label="Ano"
                  type="number"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('ano')}
                />
              </Col>
              <Col sm={12} style={{ marginTop: '20px' }}>
                <Row>
                  <Col sm={6}>
                    <label className="label">Intervalo Data de inicio</label>
                    <Row>
                      <Col sm={6}>
                        <DatePicker
                          key={'dataInicio'}
                          id="dataInicio"
                          name="dataInicio"
                          label="De"
                          onChange={this.onChangeFiltroData}
                          value={filtros.get('dataInicio')}
                          onBlur={e => {
                            this.onBlurFieldData(e);
                          }}
                        />
                      </Col>
                      <Col sm={6}>
                        <DatePicker
                          key={'dataInicioFim'}
                          id="dataInicioFim"
                          name="dataInicioFim"
                          label="Até"
                          onChange={this.onChangeFiltro}
                          value={filtros.get('dataInicioFim')}
                          onBlur={e => {
                            this.onBlurFieldData(e);
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={6}>
                    <label className="label">Intervalo Data de Término</label>
                    <Row>
                      <Col sm={6}>
                        <DatePicker
                          key={'dataTermino'}
                          id="dataTermino"
                          name="dataTermino"
                          label="De"
                          onChange={this.onChangeFiltroData}
                          value={filtros.get('dataTermino')}
                          onBlur={e => {
                            this.onBlurFieldData(e);
                          }}
                        />
                      </Col>
                      <Col sm={6}>
                        <DatePicker
                          key={'dataTerminoFim'}
                          id="dataTerminoFim"
                          name="dataTerminoFim"
                          label="Até"
                          onChange={this.onChangeFiltroData}
                          value={filtros.get('dataTerminoFim')}
                          onBlur={e => {
                            this.onBlurFieldData(e);
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <Input
                  id="objeto"
                  type="text"
                  ref="objeto"
                  name="objeto"
                  placeholder="Objeto"
                  label="Objeto"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('objeto')}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <FilterButtons
                  idBtnReset="btnResetFilter"
                  onConsulta={this.onConsultaAcordos}
                  onReset={this.onResetFiltro}
                />
              </Col>
            </Row>
          </form>
        </Panel>

        <Panel isForm expansible={false} tableResponsive>
          <Row>
            <Col xs={4}>
              <UltimaAtualizacaoByTable
                modulo="3"
                table="eloportalacordosemrecurso"
                column="dataultimaatualizacao"
              />
            </Col>
            <Col xs={8}>
              <ExportButtonGroup onClick={this.onExporta} visible={true} />
            </Col>
          </Row>

          <div className="panel-table-outer">
            <table className="panel-table striped fancy">
              <TableHeader
                text="Não foi encontrada nenhuma acordo."
                empty={page.get('content').isEmpty()}
              >
                <tr>
                  <TableHeaderItem
                    field="numero"
                    label="Número"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="ano"
                    label="Ano"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="tipo"
                    label="Tipo"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="nomeFornecedor"
                    label="Parte Contratada"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="situacao"
                    label="Situação"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="dataInicio"
                    label="Início"
                    page={page}
                    searchWithPage={this.searchWithPage}
                  />
                  <TableHeaderItem
                    field="dataTermino"
                    label="Término"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <TableHeaderItem
                    field="objeto"
                    label="Objeto"
                    page={page}
                    searchWithPage={this.searchWithPage}
                    alignment="right"
                  />
                  <th />
                </tr>
              </TableHeader>
              <tbody>{page.get('content').map(this.renderAcordos)}</tbody>
            </table>
          </div>
        </Panel>

        <SearchPagination page={page} searchWithPage={this.searchWithPage} />
      </section>
    );
  }
}

function mapStateToProps(state) {
  const tipoSituacao = fromJS([
    'Em Andamento',
    'Cancelado',
    'Paralisado',
    'Concluído'
  ]);

  return {
    page: state.acordoSemRecurso.get('acordos'),
    filtros: state.crud.getIn(['filtroAcordos', 'currentRecord'], Map({})),
    tipoSituacao: tipoSituacao
  };
}

const allActions = {
  ...actions,
  changeFieldValue,
  onChange,
  resetCrud,
  addErrorNotification
};

export default connect(mapStateToProps, allActions)(FormAcordoSemRecurso);
